import React from "react";
import { observer } from "mobx-react";

const RELEVANCE_STYLES = {
  CURRENT_MATCH: { bg: "#dcfce7", color: "#166534", label: "Current Role Match" },
  PAST_EXPERIENCE_MATCH: { bg: "#dbeafe", color: "#1e40af", label: "Past Experience Match" },
  ADJACENT_MATCH: { bg: "#fef9c3", color: "#854d0e", label: "Adjacent Match" }
};

const ProfileSummary = observer(({ profileData, structuredProfile, dataQuality }) => {
  const firstName = profileData?.firstName || "";
  const lastName = profileData?.lastName || "";
  const subTitle = profileData?.subTitle || "";
  const summary = profileData?.user_insights?.summary || "";
  const location = profileData?.location || "";

  const relevanceRaw = structuredProfile?.seller_relevance || "";
  const relevanceType = relevanceRaw.split(" ")[0]?.replace("—", "").trim();
  const relevanceStyle = RELEVANCE_STYLES[relevanceType] || null;

  const qualityColor = dataQuality?.quality === "rich" ? "#059669"
    : dataQuality?.quality === "moderate" ? "#d97706" : "#dc2626";

  return (
    <div className="drSection drProfileSection">
      <div className="drProfileHeader">
        <div className="drProfileInfo">
          <h2 className="drProfileName">{firstName} {lastName}</h2>
          <p className="drProfileTitle">{subTitle}</p>
          {location && <p className="drProfileLocation">📍 {typeof location === "string" ? location : location.default || ""}</p>}
        </div>
        <div className="drProfileBadges">
          <span className="drQualityBadge" style={{ color: qualityColor }}>
            ● {dataQuality?.quality} ({dataQuality?.score})
          </span>
        </div>
      </div>

      {summary && <p className="drProfileSummary">{summary}</p>}

      {relevanceStyle && (
        <div className="drRelevanceBadge" style={{ backgroundColor: relevanceStyle.bg, color: relevanceStyle.color }}>
          {relevanceStyle.label}: {relevanceRaw.replace(relevanceType, "").replace("—", "").trim()}
        </div>
      )}

      {/* Structured Profile Details */}
      {structuredProfile && Object.keys(structuredProfile).length > 0 && (
        <div className="drProfileDetails">
          {structuredProfile.persona_type && (
            <div className="drDetailRow">
              <span className="drDetailLabel">Persona</span>
              <span className="drDetailValue">{structuredProfile.persona_type}</span>
            </div>
          )}
          {structuredProfile.kpi_focus && (
            <div className="drDetailRow">
              <span className="drDetailLabel">KPI Focus</span>
              <span className="drDetailValue">{structuredProfile.kpi_focus}</span>
            </div>
          )}
          {structuredProfile.skepticism_profile && (
            <div className="drDetailRow">
              <span className="drDetailLabel">Will Push Back On</span>
              <span className="drDetailValue">{structuredProfile.skepticism_profile}</span>
            </div>
          )}
          {structuredProfile.disc_type && (
            <div className="drDetailRow">
              <span className="drDetailLabel">DISC Type</span>
              <span className="drDetailValue">{structuredProfile.disc_type}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
});

export default ProfileSummary;
